import { Link } from 'react-router-dom';

import getWebAppRouteKey from './getWebAppRouteKey';
import getPathName from './getPathName';

interface Options {
  currentPathName?: string;
  args?: Record<string, string>;
  query?: Record<string, string>;
  hash?: string;
}

export default function getButtonLinkProps(
  path: string,
  {
    currentPathName = typeof document !== 'undefined' ? document.location.pathname : '',
    args = {},
    query = {},
    hash,
  }: Options = {}
) {
  const isUsPath = path.startsWith('/us/'); // FIXME: remove this when we use /us for all pages

  if (path.startsWith('../')) {
    return {
      component: Link,
      to: path,
      role: 'link',
    };
  }

  if (!path.startsWith('/') || isUsPath) {
    return { component: 'a', href: path };
  }

  const isCurrentUrlWebApp =
    Boolean(getWebAppRouteKey(currentPathName)) && Boolean(document.getElementById('webapp')); // small hack since courses page are both in webapp and not in webapp for now

  const isTargetPathWebApp = Boolean(getWebAppRouteKey(path));

  const canUseWebAppRouter = isCurrentUrlWebApp && isTargetPathWebApp;
  let url = getPathName(path, args, !canUseWebAppRouter);

  // we should remove /:lang from the url if we use client side router
  if (canUseWebAppRouter && url.match(/^\/[a-z]{2}\//)) {
    url = url.substring(3);
  }

  let hashString = '';

  if (hash) {
    hashString = `#${hash}`;
  } else if (path.includes('#')) {
    const [, hashFromPath] = path.split('#');
    hashString = `#${hashFromPath}`;
  }

  let searchParams = '';

  if (Object.keys(query).length > 0) {
    searchParams = new URLSearchParams(query).toString();
  } else if (path.includes('?')) {
    searchParams = path.match(/\?([^#]+)/)?.[1] ?? '';
  }

  const finalUrl = url + (searchParams ? `?${searchParams}` : '') + hashString;

  return canUseWebAppRouter
    ? {
        component: Link,
        to: path.match(/(\?|#)/)
          ? finalUrl
          : {
              pathname: url,
              search: searchParams,
              hash,
            },
        role: 'link',
      }
    : { component: 'a', href: finalUrl };
}
